export const getArtifactSelectionKey = (artifact, fallbackIndex = 0) => {
  if (!artifact) return `artifact-${fallbackIndex}`;

  if (artifact.identifier) return artifact.identifier;
  if (artifact.id) return artifact.id;

  const title = artifact.title || 'artifact';
  const type = artifact.type || 'unknown';
  const content = artifact.content || '';

  return `${title}-${type}-${content}`;
};

export const getLastArtifactKey = (artifacts = []) => {
  if (!artifacts.length) return null;

  const lastIndex = artifacts.length - 1;

  return getArtifactSelectionKey(artifacts[lastIndex], lastIndex);
};
